module.exports = __webpack_public_path__ + "img/bg-camera-tablet-800-1280.cf8532fd.png";